export default __webpack_public_path__ + "static/media/logo.a675738d.svg";